<p-button
  styleClass="w-auto"
  severity="secondary"
  (click)="toggleSelection()"
  [disabled]="!items.length"
  size="small"
  [rounded]="true"
  [text]="true"
  [raised]="true"
  [icon]="isAllSelected() ? 'fa-regular fa-circle' : 'fas fa-check-circle'"
  [label]="isAllSelected() ? noneLabel : allLabel"></p-button>
